import { MutedAlert } from '@app/components/MutedAlert';
import { Link as MuiLink } from '@mui/material';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { Link } from 'react-router-dom';
import { socialExportPublishMessages } from './social-export-publish-messages';

export interface SocialExportNoSourcesAlertProps {
  /** Body copy explaining why publishing is blocked. */
  description: MessageDescriptor;
  /** Router path for the CTA (e.g. fragment edits or composition edits). */
  linkTo: string;
}

/**
 * Inline alert + link when there is no publishable media source (fragment or composition social export).
 */
export function SocialExportNoSourcesAlert({
  description,
  linkTo,
}: SocialExportNoSourcesAlertProps) {
  return (
    <MutedAlert sx={{ mt: 2 }}>
      <FormattedMessage {...description} />{' '}
      <MuiLink component={Link} to={linkTo} underline="hover">
        <FormattedMessage {...socialExportPublishMessages.panoramaGoToEdits} />
      </MuiLink>
    </MutedAlert>
  );
}
